import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import ModalTriggerComponent from './js/modal-trigger.component';
import ReactModal from './js/react-modal';

ComponentsFactory.getInstance().define('modal-trigger', ModalTriggerComponent);
ComponentsFactory.getInstance().defineWithCustomSelector('a[target="popup"]', ModalTriggerComponent);

export { ReactModal };
